module.exports = __webpack_public_path__ + "static/media/M52ws.b80f38db.pdf";